import React from 'react';

interface TestHeaderProps {
  title?: string;
  onBackToApp?: () => void;
  onShowReference?: () => void;
}

const TestHeader: React.FC<TestHeaderProps> = ({ 
  title = "Layout Test", 
  onBackToApp,
  onShowReference
}) => {
  return (
    <div className="layout-flex-row" style={{ 
      justifyContent: 'space-between', 
      alignItems: 'center',
      padding: '0 20px',
      height: '100%',
      color: 'white'
    }}>
      <div className="layout-flex-row">
        <span>☰</span>
        <h1 style={{ margin: '0 0 0 16px', fontSize: '18px', fontWeight: '600' }}>
          🏗️ {title}
        </h1>
      </div>
      
      <div className="layout-flex-row" style={{ gap: '12px' }}>
        <span style={{ marginRight: '8px' }}>👤 User</span>
        {onShowReference && (
          <button 
            onClick={onShowReference}
            className="btn-primary-action"
          >
            📖 CSS Reference
          </button>
        )}
        {onBackToApp && (
          <button 
            onClick={onBackToApp}
            className="btn-primary-action"
          >
            ← Back to App
          </button>
        )}
      </div>
    </div>
  );
};

export default TestHeader;